export default "__VITE_PUBLIC_ASSET__080450c7__"